// apps/client/src/world/picking.ts — tap → ground tile on the curved world (§8.7 PickHit)
import type { ItemView, Rect, ResidentId, TileXY, Vec2, VillagerId, WorldObject } from '@whiskerton/shared';
import * as THREE from 'three';
import { worldUniforms } from '../engine/shader/worldPatch';
export interface PickHit {
  tile: TileXY; point: Vec2;
  object?: WorldObject; item?: ItemView; resident?: ResidentId; villager?: VillagerId;
}
const STEP = 0.2, MAX = 220;   // ray-march step and reach in world units (precision caps, not feel numbers)
/** Marches the tap ray over the (curved) ground and returns the first tile it meets; the game fills object/item/resident from its indexes. */
export function pickGround(ndc: { x: number; y: number }, camera: THREE.Camera, heightAt: (p: Vec2) => number, bounds: Rect): { tile: TileXY; point: Vec2 } | null {
  const ray = new THREE.Raycaster();
  ray.setFromCamera(new THREE.Vector2(ndc.x, ndc.y), camera);
  const o = ray.ray.origin, d = ray.ray.direction, cam = worldUniforms.uCamXZ.value, curve = worldUniforms.uCurve.value;
  for (let t = 0; t < MAX; t += STEP) {
    const x = o.x + d.x * t, y = o.y + d.y * t, z = o.z + d.z * t;
    const dx = x - cam.x, dz = z - cam.y;
    if (y <= heightAt({ x, y: z }) - (dx * dx + dz * dz) * curve) {
      if (x < bounds.x || z < bounds.y || x >= bounds.x + bounds.w || z >= bounds.y + bounds.h) return null;
      return { tile: { x: Math.floor(x), y: Math.floor(z) }, point: { x, y: z } };
    }
  }
  return null;
}
